import { put, call } from 'redux-saga/effects';
import * as actions from 'actions/vessels/orders';
import mockOrder from 'mocks/vessel/order.json';
import moment from 'moment';
import * as actionTypes from 'constants/ActionTypes';

function* fillAndCreateVesselOrders(clarified) {
    const items = [];

    clarified.forEach((item) => {
        if (item. mVOpen) {
            const openPositions = item.mVOpen.map((openPosition) => {
                let open = moment(openPosition.open).utc().startOf('day').toDate();
                let close = moment(openPosition.close).utc().startOf('day').toDate();
    
                let currentDate = moment().startOf('day').toDate();
    
                let from = open;
                let until = close;
    
                let fromOld = '';
                let untilOld = '';
    
                if (open < currentDate) {
                    from = currentDate;
                    fromOld = open;
                }
    
                if (close < currentDate) {
                    until = currentDate;
                    untilOld = close;
                }
    
                return {
                    namePort: openPosition.name,
                    where: openPosition.where.id,
                    from,
                    until,
                    fromOld,
                    untilOld,
                };
            });
    
            items.push({
                ...mockOrder,
                open: openPositions,
                vesselName: item.mv.name,
                vessel: item.mv._id,
                imoNumber: item.mv.imoNumber,
                DWT: item.mv.dw.summer,
                BLT: item.mv.blt,
                maintenance: item.maintenance,
                disponentOwner: item.mv.disponentOwner,
            });
        } else {
            items.push(mockOrder);
        }
    });

    return items;
}

export function* createVesselOrders(response) {
    if (response.status === 200) {
        if (response.data.clarified && response.data.clarified.length > 0) {

            const vesselOrders = yield call(fillAndCreateVesselOrders, response.data.clarified);
            
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Created',
                    message: `${vesselOrders.length} vessel orders created`,
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });

            yield put(actions.createVesselOrders(vesselOrders));
        } else {
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Warning',
                    message: `Vessel orders did't create`,
                    level: 'warning',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });

            yield put(actions.addVesselOrder());
        }
    } else {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: `Vessel orders did't create`,
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });

        yield put(actions.addVesselOrder());
    }
}



// WEBPACK FOOTER //
// ./app/sagas/vessels/orders.js